import React, { useState } from "react";
import Flags from "./Flags";

const Bazinga = ({ isFrance }) => {
  const [isFranceFound, setIsFranceFound] = useState(false);
  if (isFrance) {
  }
  return <></>;
};

export default Bazinga;
